export default __webpack_public_path__ + "static/brand-image_1x-72e5f8e7d584e7b6604bf82508e4b81d.jpg";